export const LANDING_PAGE_KILL_ANIMATION = 'LANDING_PAGE_KILL_ANIMATION';
export const LANDING_PAGE_RESUME_ANIMATION = 'LANDING_PAGE_RESUME_ANIMATION';
